/**
 * A helper service that provides functions to assist with translation related operations.
 */
export class TranslationHelperService {
  constructor(
    private $translate: ng.translate.ITranslateService,
    private $q: ng.IQService,
    private $cookies: ng.cookies.ICookiesService
  ) {}

  /**
   * Function that attempts initialise the angular translation service with the browser language. If no translation file
   * exists for the language set by the browser, then the fallback language is used instead.
   *
   * @param preferredLanguage The preferred language to be used by the angular translation service
   * @param fallbackLanguage The fallback language to be used by the angular translation service
   * @returns A promise that resolves when the language has been set
   */
  public initialiseAppTranslations(preferredLanguage: string, fallbackLanguage: string) {
    const deferred = this.$q.defer();
    this.$translate.use(preferredLanguage).then(() => {
      this.$translate.preferredLanguage(preferredLanguage);
      this.$cookies.put('actora_language', preferredLanguage);
      this.$translate.refresh();
      deferred.resolve(preferredLanguage);
    }).catch(() => {
      this.$translate.use(fallbackLanguage).then(() => {
        this.$cookies.put('actora_language', fallbackLanguage);
        deferred.resolve(fallbackLanguage);
      });
    });

    return deferred.promise;
  }

  /**
   * A method that returns the language stored in the actora_language cookie. If the cookie
   * does not exist then the browser language is used instead.
   *
   * @returns the language stored in the cookie (or from the browser if the cookie does not exist)
   */
  public getLanguageFromCookie() {
    const languageFromCookie = this.$cookies.get('actora_language');
    return languageFromCookie ? languageFromCookie : navigator.language;
  }
}
